module.exports = "<dw-layout-basic-side>\n</dw-layout-basic-side>\n"